import { combineReducers } from 'redux';
import sessionReducer from './session';
import userReducer from './user';
import appReducer from './app';

const rootReducer = combineReducers({
  sessionState: sessionReducer,
  userState: userReducer,
  appState: appReducer,
});

export default rootReducer;


// WEBPACK FOOTER //
// ./src/reducers/index.js